import { useEffect, useState } from "react";

export const useDebouncedState = (initialValue: string = ""): [string, string, (v: string) => void] => {
  const [value, setValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const tid = setTimeout(() => {
      setDebouncedValue(value);
    }, 500);

    return () => {
      clearTimeout(tid);
    }
  }, [value]);

  return [debouncedValue, value, setValue];
}